export default "__VITE_PUBLIC_ASSET__a01be617__"